define('builderShowcaseGalleryStateHandler',['builderShowcaseObserver'], (builderShowcaseObserver) => {
  'use strict';

  /**
   * @private
   * Used to save the collections from the template, and into the BSP state
   */
  function saveGalleryCollectionsIntoState() {
    const collectionsObject = document.querySelector('[data-gallery-collections]');
    if (collectionsObject) {
      const collections = JSON.parse(collectionsObject.innerHTML);

      builderShowcaseObserver.setData({
        collections
      });
      builderShowcaseObserver.commit();
    }
  }

  /**
   * Used to get the list of images to display.
   * @param {Array} collections the image collections.
   * @param {string} category the current active collection.
   */
  function getCollectionFromState(category) {
    const state = builderShowcaseObserver.getState();
    const collections = state.data.collections;
    const collection = collections.find((element) => element.Category === category ||
      element.Name === category);

    return collection;
  }

  saveGalleryCollectionsIntoState();

  return {
    getCollection: getCollectionFromState
  };
});

